import useChangePasswordForm from "./UseChangePasswordForm";

import Input from "../../../inputs/Input";
import PasswordInput from "../../../inputs/PasswordInput";
import PrimaryButton from "../../../buttons/PrimaryButton";
import SecondaryButton from "../../../buttons/SecondaryButton";
import PasswordRequirementsList from "../../../inputs/PasswordRequirementsList";

import style from '../LoginForms.module.css';

const ChangePasswordForm = ({ submitButtonText = 'Save', secondaryButtonText = 'Back', verticalButtons = false,
  userName, onSubmitFormCallback, onSecondaryButtonClicked }) => {
  const {
    formState,
    errorState,
    requirementsState,
    enableSaveButtonState,
    handleSubmit,
    updateFormState,
    onNewPasswordChanged,
  } = useChangePasswordForm(onSubmitFormCallback, userName);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Input
            label='Recovery Code*'
            name="recoveryCode"
            value={formState.recoveryCode}
            error={errorState.recoveryCode}
            message={errorState.recoveryCode}
            onChange={(value) => { updateFormState('recoveryCode', value) }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <PasswordRequirementsList passwordRequirementsState={requirementsState} />
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <PasswordInput
            label='New Password*'
            name="newPassword"
            value={formState.newPassword}
            error={errorState.newPassword}
            message={errorState.newPassword}
            onChange={(value) => { onNewPasswordChanged(value) }} />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <PasswordInput
            label='Confirm New Password*'
            name="confirmPassword"
            value={formState.confirmPassword}
            error={errorState.confirmPassword}
            message={errorState.confirmPassword}
            onChange={(value) => { updateFormState('confirmPassword', value) }} />
        </div>
      </div>
      <div className="row">
        <div className={["col-xs-12 usas-extra-top-margin", style.FormButtons, verticalButtons ? style.Vertical : ''].join(' ')}>
          <PrimaryButton isDisabled={enableSaveButtonState !== true} type="submit">{submitButtonText}</PrimaryButton>
          <SecondaryButton type="button" onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default ChangePasswordForm;